const FouSelectData = (() => {
  // Pattern to pass object key pairs between API values and fou-select options
  // Names of API value keys can vary
  // Fou-Select only accepts objects with value and label keys

  let _o = {} // Object
  let _k = {} // Keys

  const _getType = () => {
    if (Array.isArray(_o)) {
      return 'array'
    }
    if (typeof _o === 'object') {
      return 'object'
    }
    return 'unaccepted type'
  }

  const _isValidObject = (obj) => {
    obj = obj || _o || {}
    const isValid = (
      (typeof obj.value !== 'undefined' || typeof obj[_k.value] !== 'undefined') &&
      (typeof obj.label === 'string' || typeof obj[_k.name] === 'string')
    )
    return isValid
  }

  const _hasName = (obj) => {
    obj = obj || _o
    return obj[_k.name] !== ''
  }

  const _selectObject = (obj) => {
    obj = obj || _o
    const result = {
      value: obj[_k.value] || 0,
      label: obj[_k.name] // label must not be '' in fou-select label
    }
    if (obj.subTitle) result.subTitle = obj.subTitle
    return result
  }

  const _apiObject = (obj) => {
    obj = obj || _o
    return {
      [_k.value]: (obj.value === '' ? 0 : obj.value) || 0,
      [_k.name]: obj.label || ''
    }
  }

  const _clear = () => {
    _o = {}
    _k = {}
  }

  const _set = (options) => {
    _o = options.obj
    _k = {
      value: options.value,
      name: options.name,
      multiple: options.multiple || false
    }
  }

  function getOptions (options) {
    // Add arguments to private collection
    _set(options)
    // To return multiple values from array set options.multiple to true
    // Otherwise first array item will be returned to make sure single select dont display array code
    // Array should consist of Objects that must include a 'name' property
    if (_getType() === 'array') {
      const items = []
      for (const item of _o) {
        if (_isValidObject(item)) {
          if (_hasName(item)) items.push(_selectObject(item))
        }
      }
      return _k.multiple && items.length > 0
        ? items
        : typeof items[0] === 'object'
          ? items[0]
          : null
    }
    // If type is object option it is supposingly for a fou-select field with a single value
    // Make sure that requested keys are of type string and that 'name' is not an empty
    if (_getType() === 'object') {
      if (_isValidObject()) {
        return _hasName() ? _selectObject() : null
      }
    }
    // Clear Keys
    _clear()
    // For all other cases return null to set empty option
    return null
  }

  function getValues (options) {
    // Add arguments to private collection
    _set(options)
    // To return multiple values from array set options.multiple to true
    // Otherwise only first array item or empty object will be returned to make sure not to post arrays on object definitions
    // Array should consist of Objects that must include a 'apiNameField' property
    if (_getType() === 'array') {
      const items = []
      for (const item of _o) {
        if (_isValidObject(item)) items.push(_apiObject(item))
      }
      return (_k.multiple) ? items : (items[0] || {})
    }
    // If type is object option it is supposingly coming from a single value fou-select field
    // Make sure that requested keys are of type string and that 'name' is not an empty
    if (_getType() === 'object') {
      return _isValidObject() ? _apiObject() : {}
    }
    // Clear Keys
    _clear()
  }

  return {
    getSelectOptions: getOptions,
    getApiValues: getValues
  }
})()

const FouSelectObject = function () {
  return {
    state: 'unset',
    setted: function () {
      /**
       * Setting back to ‘set’ as mentioned in setValues.
       */
      this.state = 'set'
    },
    isSet: function () {
      return this.state === 'set'
    },
    options: [],
    values: null,
    setOptions: function (options = {}) {
      const o = FouSelectData.getSelectOptions(options)
      this.options = o === null ? [] : o
    },
    setValues: function (options = {}) {
      this.state = 'setting'
      /**
       * When setting values fou-select triggers on-change.
       * To prevent of firing update() during this phase set state to ‘setting'.
       * Afterwards ‘set’ will be set after update to allow user updates.
       * This wont work for empty values – see below!
       */
      this.values = FouSelectData.getSelectOptions(options)
      /**
       * null updates do not get triggered. So set manually.
       */
      if (this.values === null) {
        this.setted()
      }
    },
    getApiValues: function (options) {
      options.obj = this.values
      return FouSelectData.getApiValues(options)
    },
    remove: function (key, cb) {
      if (key === undefined) {
        const arrLength = this.values.length
        this.values.splice(0, arrLength)
        return
      }
      this.values.splice(key, 1)
      if (typeof cb === 'function') {
        cb()
      }
    },
    update: function (val, cb) {
      if (this.state === 'set') {
        this.values = val
        if (typeof cb === 'function') {
          cb()
        }
      }
      this.setted()
    }
  }
}

export {
  FouSelectData,
  FouSelectObject
}
